import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  // base: process.env.BASE_URL,
  base: process.env.CUSTOM_ENV==='production'?"/wap/lrb-zhkd-web/":'/lrb-zhkd-web/',
  routes:[
    {
      path: '/',
      name: '/',
      component: () => import('@/views/index.vue'),
      meta: {
        title: '中恒科迪',
      }
    },
    {
      path: '/index',
      name: 'index',
      component: () => import('@/views/index.vue'),
      meta: {
        title: '中恒科迪',
      }
    },

  ]
})

export default router
